// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SettingsPreview } from './SettingsPreview';

export const CommercialAgreementsPreview: React.FC = () => {
  const nav = useNavigate();
  const go = () => {
    nav('commercial-agreements', { state: { pageName: 'Commercial Agreements' } });
  };
  return (
    <SettingsPreview
      title="Commercial Agreements"
      desc="View and modify commercial agreements"
      onClick={go}
      enableBodyClick
    />
  );
};
